// extracted by mini-css-extract-plugin
export default {"Form":"BookForm_Form__HL7VY","Stars":"BookForm_Stars__POySG","AddImage":"BookForm_AddImage__kQypF"};